import { Modal, ModalContainer, type ModalProps } from "@stenajs-webui/modal";
import type { FC } from "react";

export interface BaseModalProps extends Omit<
  ModalProps,
  "isOpen" | "preventScroll"
> {
  disablePortal?: boolean;
  isOpen?: boolean;
}

export const getModalRoot = (
  id: "modal-root" | "routeless-modal-root",
): HTMLElement => {
  const container = document.getElementById(id);
  if (!container) {
    // tslint:disable-next-line
    console.error(`Target element "#${id}" is not in dom`);
    return document.body;
  }
  return container;
};

export const BaseModal: FC<BaseModalProps> = ({
  children,
  isOpen = true,
  disablePortal = false,
  ...props
}) => {
  return (
    <Modal
      {...props}
      preventScroll
      isOpen={isOpen}
      parentSelector={
        !disablePortal ? () => getModalRoot("modal-root") : undefined
      }
    >
      <ModalContainer>{children}</ModalContainer>
    </Modal>
  );
};
